/** @format */

import React, { forwardRef } from 'react';

const Typography = forwardRef((props, ref) => {
  const { as: Tag = 'p', children, ...rest } = props;
  return (
    <Tag ref={ref} {...rest}>
      {children}
    </Tag>
  );
});
export default Typography;
